import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Login from '../views/Login/Login';
import RequestPassChange from '../views/RequestPassChange/RequestPassChange';
import ChangePassword from '../views/ChangePassword/ChangePassword';
import MainLayout from '../layout/MainLayout/MainLayout';
import Home from '../views/Home/Home';
import Calendar from '../views/Calendar/Calendar';
import ContractGenerator from '../views/ContractGenerator/ContractGenerator';
import Contracts from 'views/Contracts/Contracts';
import DailyState from '../views/DailyState/DailyState';
import Tasks from '../views/Tasks/Tasks';
import LegalCases from '../views/LegalCases/LegalCases';
import Clients from '../views/Clients/Clients';
import ClientsDetail from '../views/Clients/ClientsDetail/ClientsDetail';
import CallDetail from '../views/Clients/ClientsDetail/partial/CallDetail';
import IdMonitoring from '../views/IdMonitoring/IdMonitoring';
import Collection from '../views/Collection/Collection';
import Schedule from '../views/Schedule/Schedule';
import DocumentManagement from '../views/DocumentManagement/DocumentManagement';
import DocumentRegister from '../views/DocumentRegister/DocumentRegister';
import CreateMessages from '../views/CreateMessages/CreateMessages';
import Campaigns from '../views/Campaigns/Campaigns';
import TasksNotifications from '../views/TasksNotifications/TasksNotifications';
import WorkflowTaskConfig from '../views/WorkflowTaskConfig/WorkflowTaskConfig';
import ApprovalRequest from '../views/ApprovalRequest/ApprovalRequest';
import LawyersScoring from '../views/LawyersScoring/LawyersScoring';
import TemplatesUse from '../views/TemplatesUse/TemplatesUse';
import DetectionMonitoring from '../views/DetectionMonitoring/DetectionMonitoring';
import Protocols from '../views/Protocols/Protocols';
import ProtocolGeneralDetail from '../views/Protocols/ProtocolGeneralDetail';
import NoClients from '../views/NoClients/NoClients';
import MarketingAnalysis from '../views/Marketing/MarketingAnalysis';
import MarketingSacTranscripts from '../views/Marketing/MarketingSacTranscripts';
import MarketingGeneralAnalysisWip from '../views/Marketing/MarketingGeneralAnalysisWip';
import MarketingCallDetail from '../views/Marketing/MarketingCallDetail';

import Configuration from '../views/Configuration/Configuration';
import Company from '../views/Configuration/pages/Company/Company';
import Users from '../views/Configuration/pages/Users/Users';
import Roles from '../views/Configuration/pages/Roles/Roles';
import ServiceProtocol from '../views/Configuration/pages/ServiceProtocol/ServiceProtocol';
import DocumentDelivery from '../views/Configuration/pages/DocumentDelivery/DocumentDelivery';
import Integrations from '../views/Configuration/pages/Integrations/Integrations';
import ApiManagement from '../views/Configuration/pages/ApiManagement/ApiManagement';
import Delegations from '../views/Configuration/pages/Delegations/Delegations';
import AuditLog from '../views/Configuration/pages/AuditLog/AuditLog';
import LoginLog from '../views/Configuration/pages/LoginLog/LoginLog';
import IpManagement from '../views/Configuration/pages/IpManagement/IpManagement';
import Profile from '../views/Configuration/pages/Profile/Profile';
import Payments from '../views/Configuration/pages/Payments/Payments';
import RoleoAutomatico from '../views/Configuration/pages/RoleoAutomatico/RoleoAutomatico';

import DataManagement from '../views/Configuration/pages/DataManagement/DataManagement';
import ConfigCourts from '../views/Configuration/pages/DataManagement/ConfigCourts/ConfigCourts';
import ConfigBusiness from '../views/Configuration/pages/DataManagement/ConfigBusiness/ConfigBusiness';
import ConfigService from '../views/Configuration/pages/DataManagement/ConfigService/ConfigService';
import ConfigTasks from '../views/Configuration/pages/DataManagement/ConfigTasks/ConfigTasks';
import ConfigAreas from '../views/Configuration/pages/DataManagement/ConfigAreas/ConfigAreas';
import ConfigExcluded from '../views/Configuration/pages/DataManagement/ConfigExcluded/ConfigExcluded';
import CaseDetails from '../views/LegalCases/CaseDetails/CaseDetails';
import CaseMovements from '../views/LegalCases/CaseDetails/ConfigMovements/CaseMovements';
import CaseTasks from '../views/LegalCases/CaseDetails/ConfigTasks/CaseTasks';
import LoaderPreDS from 'components/LoaderPreDS/LoaderPreDS';
import Impersonate from 'views/Impersonate/Impersonate';
import CaseOldMovements from 'views/LegalCases/CaseDetails/ConfigOldMovements/CaseOldMovements';
import NoClientsProtocolAnalisys from 'views/NoClients/Analisys/ProtocolAnalisys';
import NoClientTranscriptView from 'views/NoClients/Analisys/TranscriptView';
import ReportCreator from 'views/ReportCreator/ReportCreator';
import PermissionRoute from './guards/PermissionRoute';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

const ProtectedRoute = ({ isAuthenticated, mustChangePassword, element, initializing }) => {
  if (initializing) return <LoaderPreDS />;
  if (!isAuthenticated) return <Navigate to='/login' replace />;
  if (mustChangePassword) return <Navigate to='/cambiar-contrasena' replace />;

  return element;
};

const AppRoutes = ({ DesignSystemComponents }) => {
  const { isAuthenticated, initializing, mustChangePassword } = useAuth();

  return (
    <Routes>
      <Route
        path='/login'
        element={<Login DesignSystemComponents={DesignSystemComponents} />}
      />
      <Route
        path='/solicitud-nueva-contrasena'
        element={
          <RequestPassChange DesignSystemComponents={DesignSystemComponents} />
        }
      />
      <Route
        path='/cambiar-contrasena'
        element={<ChangePassword />}
      />

      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuthenticated}
            mustChangePassword={mustChangePassword}
            element={
              <MainLayout DesignSystemComponents={DesignSystemComponents} />
            }
            initializing={initializing}
          />
        }
      >
        <Route
          path='/'
          element={<Home DesignSystemComponents={DesignSystemComponents} />}
        />
        <Route
          path='/impersonate'
          element={
            <Impersonate DesignSystemComponents={DesignSystemComponents} />
          }
        />
        <Route
          path='/mi-perfil'
          element={<Profile DesignSystemComponents={DesignSystemComponents} />}
        />
        <Route
          path='/calendar'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CALENDAR}
              element={
                <Calendar DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/generador-contratos/generador'
          element={
            <ContractGenerator
              DesignSystemComponents={DesignSystemComponents}
            />
          }
        />
        <Route
          path='/generador-contratos/contratos'
          element={
            <Contracts DesignSystemComponents={DesignSystemComponents} />
          }
        />
        <Route
          path='/estado-diario'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.DAILY_STATE}
              element={
                <DailyState DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />

        <Route
          path='/tareas'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.TASKS}
              element={
                <Tasks DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />

        <Route
          path='/causas'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CASES}
              element={
                <LegalCases DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/detalle-causa/:id'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CASES}
              element={
                <CaseDetails DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        >
          <Route index element={<Navigate to='movimientos' replace />} />
          <Route
            path='movimientos'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.CASES}
                element={
                  <CaseMovements
                    DesignSystemComponents={DesignSystemComponents}
                  />
                }
              />
            }
          />
          <Route
            path='tareas'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.CASES}
                element={
                  <CaseTasks DesignSystemComponents={DesignSystemComponents} />
                }
              />
            }
          />
          <Route
            path='movimientos-legacy'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.CASES}
                element={
                  <CaseOldMovements
                    DesignSystemComponents={DesignSystemComponents}
                  />
                }
              />
            }
          />
        </Route>

        <Route
          path='/crm/clientes'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CRM}
              element={
                <Clients DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/crm/detalles-cliente/:id'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CRM}
              element={
                <ClientsDetail
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/crm/detalles-llamada/:id'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CRM}
              element={
                <CallDetail DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/crm/monitoreo-rut'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CRM}
              element={
                <IdMonitoring DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/crm/cobranza'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.CRM}
              element={
                <Collection DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/agenda'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.AGENDA}
              element={
                <Schedule DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />

        <Route
          path='/smart-docs/gestion-documentos'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.SMART_DOCUMENTS}
              element={
                <DocumentManagement
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/smart-docs/registro-documentos'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.SMART_DOCUMENTS}
              element={
                <DocumentRegister
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />

        <Route
          path='/mensajeria/crear-mensajes'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MESSAGING}
              element={
                <CreateMessages
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/mensajeria/campanas'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MESSAGING}
              element={
                <Campaigns DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/mensajeria/tareas-notificaciones'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MESSAGING}
              element={
                <TasksNotifications
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />

        <Route
          path='/automatizaciones/configurar-workflow-tareas'
          element={
            <WorkflowTaskConfig
              DesignSystemComponents={DesignSystemComponents}
            />
          }
        />
        <Route
          path='/automatizaciones/solicitudes-aprobacion'
          element={
            <ApprovalRequest DesignSystemComponents={DesignSystemComponents} />
          }
        />
        <Route
          path='/automatizaciones/configuracion-workflow-tareas'
          element={
            <Navigate
              to='/automatizaciones/configurar-workflow-tareas'
              replace
            />
          }
        />
        <Route
          path='/automatizaciones/solicitud-aprobacion'
          element={
            <Navigate to='/automatizaciones/solicitudes-aprobacion' replace />
          }
        />

        <Route
          path='/informes/scoring-abogados'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.REPORTS}
              element={
                <LawyersScoring
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/informes/uso-plantillas'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.REPORTS}
              element={
                <TemplatesUse DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/informes/deteccion-monitoreo'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.REPORTS}
              element={
                <DetectionMonitoring
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/informes/creador-informes'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.REPORTS}
              element={
                <ReportCreator
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />

        <Route
          path='/ia/protocolos'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE}
              element={
                <Protocols DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/ia/no-clientes'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE}
              element={
                <NoClients DesignSystemComponents={DesignSystemComponents} />
              }
            />
          }
        />
        <Route
          path='/ia/no-clientes/analisis-protocolo'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE}
              element={
                <NoClientsProtocolAnalisys
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/ia/no-clientes/analisis-protocolo/transcripcion/:id'
          element={
            <NoClientTranscriptView
              DesignSystemComponents={DesignSystemComponents}
            />
          }
        />
        <Route
          path='/ia/protocolos/detalle-general'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.ARTIFICIAL_INTELLIGENCE}
              element={
                <ProtocolGeneralDetail
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />

        {/* Marketing */}
        <Route
          path='/marketing/analisis-marketing'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MARKETING}
              element={
                <MarketingAnalysis
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/marketing/transcripciones-sac'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MARKETING}
              element={
                <MarketingSacTranscripts
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/marketing/analisis-general'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MARKETING}
              element={
                <MarketingGeneralAnalysisWip
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />
        <Route
          path='/detalles-llamada/:id'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.MARKETING}
              element={
                <MarketingCallDetail
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        />

        {/* Configuration */}
        <Route
          path='/configuracion'
          element={
            <PermissionRoute
              requiredModule={MODULE_KEY_MAP.SETTINGS}
              element={
                <Configuration
                  DesignSystemComponents={DesignSystemComponents}
                />
              }
            />
          }
        >
          <Route index element={<Navigate to='empresa' replace />} />
          <Route
            path='empresa'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<Company />}
              />
            }
          />
          <Route
            path='usuarios'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<Users />}
              />
            }
          />
          <Route
            path='roles'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={
                  <Roles DesignSystemComponents={DesignSystemComponents} />
                }
              />
            }
          />

          <Route
            path='gestion-datos'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<DataManagement />}
              />
            }
          >
            <Route index element={<Navigate to='tribunales' replace />} />
            <Route path='tribunales' element={<ConfigCourts />} />
            <Route path='negocios' element={<ConfigBusiness />} />
            <Route path='servicios' element={<ConfigService />} />
            <Route path='tareas' element={<ConfigTasks />} />
            <Route path='areas' element={<ConfigAreas />} />
            <Route path='excluidos' element={<ConfigExcluded />} />
            <Route path='*' element={<Navigate to='tribunales' replace />} />
          </Route>
          <Route
            path='roleo-automatico'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<RoleoAutomatico />}
              />
            }
          />

          <Route
            path='protocolo'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<ServiceProtocol />}
              />
            }
          />
          <Route
            path='envio-documentos'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<DocumentDelivery />}
              />
            }
          />
          <Route path='integraciones' element={<Integrations />} />
          <Route path='apis' element={<ApiManagement />} />
          <Route
            path='payments'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<Payments />}
              />
            }
          />
          <Route path='suplencias' element={<Delegations />} />
          <Route
            path='log-auditoria'
            element={
              <PermissionRoute
                requiredModule={MODULE_KEY_MAP.SETTINGS}
                element={<AuditLog />}
              />
            }
          />
          <Route path='log-login' element={<LoginLog />} />
          <Route path='gestion-ip' element={<IpManagement />} />

          <Route path='*' element={<Navigate to='empresa' replace />} />
        </Route>
      </Route>

      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default AppRoutes;
